import { render, staticRenderFns } from "./PlaneCard.vue?vue&type=template&id=517e11ba&scoped=true"
import script from "./PlaneCard.vue?vue&type=script&lang=js"
export * from "./PlaneCard.vue?vue&type=script&lang=js"
import style0 from "./PlaneCard.vue?vue&type=style&index=0&id=517e11ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517e11ba",
  null
  
)

export default component.exports